module.exports = __webpack_public_path__ + "img/icon-prosegur.fe8b1485.svg";